var map = {
	"./icon_my_invoice_0.png": "8d9c",
	"./icon_my_invoice_1.png": "a504",
	"./icon_my_invoice_2.png": "0d5b",
	"./icon_my_invoice_3.png": "5806"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10da";